"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Body = void 0;
const react_1 = __importDefault(require("react"));
const useIsomorphicLayoutEffect_1 = __importDefault(require("../../../../../shared/hooks/useIsomorphicLayoutEffect"));
const Thread_styles_1 = require("../../Thread.styles");
const ThreadContext_1 = require("../../ThreadContext");
/**
 * An unordered list to display the list of messages
 * and other such elements.
 *
 * It handles the automatic scrolling to ScrollAnchor, if it is used
 */
const Body = ({ children }) => {
    const { scrollAnchorRef } = (0, ThreadContext_1.useThread)();
    (0, useIsomorphicLayoutEffect_1.default)(() => {
        if (scrollAnchorRef.current) {
            scrollAnchorRef.current.scrollIntoView();
        }
    });
    return react_1.default.createElement(Thread_styles_1.StyledThreadBodyContainer, null, children);
};
exports.Body = Body;
//# sourceMappingURL=Body.js.map